export const environment = {
  production: false,
  apiUrl: "https://api1.as-dev98706.club/api/",
  bareUrl: "dev.sourcecode.pro",
  signalrHubUrl: "https://api1.as-dev98706.club/signalr",
  environment: "development"
};
